import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IReport {
	report: false;
}

const initialState: IReport = {
	report: false,
};

export const reportSlice = createSlice({
	name: "report",
	initialState,
	reducers: {
		updateReport: (state, actions: PayloadAction<any>) => {
			state.report = actions.payload;
		},
	},
});

export const { updateReport } = reportSlice.actions;

export default reportSlice.reducer;
